guia.component('guia.guiaComponent', {
    templateUrl: 'guia/guia.html',
    controller: 'guia.guiaController',
    controllerAs: '$ctrl'
});

guia.controller('guia.guiaController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', function($rootScope, $scope, $text, $state, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl._areaMembros = {};
    $ctrl.areaMembros = {};

    const _checkAcessoGuia=(idGuia)=>{
        $state.params.showGlobalLoading = true;

        const guia = $ctrl._areaMembros.data[idGuia];

        let idProdutos = []
        Object.keys(guia.produtosAcesso).forEach(key=>{ 
            if(guia.produtosAcesso[key]){ idProdutos.push(key); }
        });
        
        $fb.functions.invoke('fatura_hasProdutos', {idProdutos: idProdutos}).then(res=>{
            if(!res){ 
                $state.params.showGlobalLoading = false;

                if(guia.linkCompra){ 
                    $state.go('cliente.inicio');
                    window.location.href = guia.linkCompra; 
                }else{
                    $state.go('cliente.erroPermissao');
                };

            }else{
                $ctrl.areaMembros = angular.copy($ctrl._areaMembros);
                $ctrl.guia = guia;
                $ctrl.guia.id = idGuia;
                $state.params.showGlobalLoading = false;
            }
            
        }).catch(e=>{
            $state.go('cliente.erroPermissao');
            $state.params.showGlobalLoading = false;
        });
    };

    const _getAreaMembros=(idArea, idGuia)=>{
        $fb.db.get(`cad_areaMembros/${idArea}`).then(doc=>{
            $ctrl._areaMembros = doc;

            _checkAcessoGuia(idGuia);

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.goLink=(link)=>{
        if(!link){
            return;
        }

        window.open(link, '_blank');
    };

    $ctrl.$onInit = () => {
        let idGuia = $state.params.idGuia;

        if(!idGuia){
            $state.go('cliente.inicio');
            return;
        };

        let idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _getAreaMembros(idAreaMembros, idGuia);
        $scope.isDesktop = $rootScope.isDesktop;
    };
    
}]);